











































































import { Component, Vue, Watch } from 'vue-property-decorator'
import BackofficeMotivoRecusaOrcamentoStore from '@/components/Backoffice/Store/BackofficeMotivoRecusaOrcamentoStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalSuporteMotivoRecusaOrcamento extends Vue {
  get getBackofficeMotivoRecusaOrcamentoStore() {
    return getModule(BackofficeMotivoRecusaOrcamentoStore, this.$store)
  }

  loadSaveOrUpdateMotivoRecusaOrcamento: boolean = false
  get loadingSaveOrUpdateMotivoRecusaOrcamento() { return this.loadSaveOrUpdateMotivoRecusaOrcamento }
  set loadingSaveOrUpdateMotivoRecusaOrcamento(value: boolean) { this.loadSaveOrUpdateMotivoRecusaOrcamento = value }

  get showModalMotivoRecusaOrcamento() { return this.getBackofficeMotivoRecusaOrcamentoStore.modal.motivoRecusaOrcamento }
  set showModalMotivoRecusaOrcamento(value: boolean) { this.getBackofficeMotivoRecusaOrcamentoStore.setModal({ name: 'motivoRecusaOrcamento', value }) }

  $refs!: {
    formMotivoRecusaOrcamento: any
  }

  formMotivoRecusaOrcamentoRules: any = {
    valid: true,
    descricao: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  async saveOrUpdateMotivoRecusaOrcamento() {
    this.loadingSaveOrUpdateMotivoRecusaOrcamento = true

    if (this.$refs.formMotivoRecusaOrcamento.validate()) {
      const { mode } = this.getBackofficeMotivoRecusaOrcamentoStore

      const response = await this.getBackofficeMotivoRecusaOrcamentoStore.upsertMotivoDeRecusaDoOrcamento()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Motivo de recusa ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getBackofficeMotivoRecusaOrcamentoStore.getMotivoDeRecusaDoOrcamentoByHospitalId()
        this.showModalMotivoRecusaOrcamento = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o motivo de recusa ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateMotivoRecusaOrcamento = false
  }

  @Watch('showModalMotivoRecusaOrcamento')
  onChangeshowModalMotivoRecusaOrcamento(value: boolean) {
    if (!value) {
      this.getBackofficeMotivoRecusaOrcamentoStore.clearMotivoRecusaOrcamento()
      this.getBackofficeMotivoRecusaOrcamentoStore.setMode('CREATE')
      this.$refs.formMotivoRecusaOrcamento.resetValidation()
    }
  }
}
